import { CookieService } from "ngx-cookie-service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class SDPTranslationStorage {

  constructor(private _cookieService: CookieService) { }

  getItem(key: string): string {
    let lang = this._cookieService.get(key);
    return lang;
  }

  setItem(key: string, data: string) {
    // set path because If no path or domain is explicitly defined, the current location is assumed.
    this._cookieService.set(key, data, undefined, '/', undefined, true, "None");
  }
}
